import type { Product } from '#root/api/clients/product/data-contracts'

export const isCustomsProduct = (productDetail: MaybeRef<Product | null>) => {
  const product = toValue(productDetail)

  const hasRecipe = !!(product?.customsExternalUrl || product?.customsRecipeID)
  return hasRecipe && !!(product?.isCustoms || product?.dummyCustoms || product?.customsCustomizer)
}
